import axios from '@/http'
import getUrl from './path'

const iotHome = {
    // getAllInfo(data){ // 一般接口
    //   return axios({
    //     method:'POST',
    //     url: getUrl('/login'),
    //     data:data
    //   })
    // },
    // addInfoDataRequest(data){ // 文件上传格式
    //   return axios({
    //     method: 'POST',
    //     url: getUrl(''),
    //     processData : false,
    //     //contentType : false,
    //     dataType: 'formData',
    //     data: data,
    //     contentType: 'multipart/form-data',
    //   })
    // },
    login(data) { // 登录
        return axios({
            method: 'GET',
            url: getUrl('/web/login'),
            params: data
        })
    },
    SendMessage(data) { // 发送短信
        return axios({
            method: 'GET',
            url: getUrl('/web/SendMessage'),
            params: data
        })
    },
    verifyLogin(data) { // 验证是否登录
        return axios({
            method: 'GET',
            url: getUrl('/web/verifyLogin'),
            params: data
        })
    },
    pay(data) { // pc支付宝
        return axios({
            method: 'POST',
            url: getUrl('/web/getAliPayQrCode'),
            data: data
        })
    },
    alipay(data) { // h5支付宝
        return axios({
            method: 'POST',
            url: getUrl('/web/alipay'),
            data: data
        })
    },
    toPay(data) { // 银联
        return axios({
            method: 'POST',
            url: getUrl('/web/toPay'),
            data: data
        })
    },
    cartCount(data) { // 购物车数量
        return axios({
            method: 'GET',
            url: getUrl('/web/cartCount'),
            params: data
        })
    },
    home(data) { // 首页
        return axios({
            method: 'GET',
            url: getUrl('/web/home'),
            params: data
        })
    },
    levelNavigation(data) { // 内页的banner+页头信息
        return axios({
            method: 'GET',
            url: getUrl('/web/levelNavigation'),
            params: data
        })
    },
    companyInfo(data) { // 站点
        return axios({
            method: 'GET',
            url: getUrl('/web/companyInfo'),
            params: data
        })
    },
    bannerList(data) { //banner
        return axios({
            method: 'GET',
            url: getUrl('/web/bannerList'),
            params: data
        })
    },
    productSearch(data) { // 搜索
        return axios({
            method: 'GET',
            url: getUrl('/web/productSearch'),
            params: data
        })
    },
    aboutFhNavigation(data) { // 关于奉航导航栏
        return axios({
            method: 'GET',
            url: getUrl('/web/aboutFhNavigation'),
            params: data
        })
    },
    getList(data) {
        return axios({
            method: 'GET',
            url: getUrl('/web/getList'),
            params: data
        })
    },
    aboutFhDetails(data) { // 关于奉航详情
        return axios({
            method: 'GET',
            url: getUrl('/web/aboutFhDetails'),
            params: data
        })
    },
    newsNavigation(data) { // 新闻中心导航栏
        return axios({
            method: 'GET',
            url: getUrl('/web/newsNavigation'),
            params: data
        })
    },
    allNewsTable(data) { // 新闻中心全部列表
        return axios({
            method: 'GET',
            url: getUrl('/web/allNewsTable'),
            params: data
        })
    },
    newsTable(data) { // 新闻中心列表
        return axios({
            method: 'GET',
            url: getUrl('/web/newsTable'),
            params: data
        })
    },
    newsDetails(data) { // 新闻中心详情
        return axios({
            method: 'GET',
            url: getUrl('/web/newsDetails'),
            params: data
        })
    },
    productNavigation(data) { // 产品中心导航栏
        return axios({
            method: 'GET',
            url: getUrl('/web/productNavigation'),
            params: data
        })
    },
    productClass(data) { // 产品中心列表
        return axios({
            method: 'GET',
            url: getUrl('/web/productClass'),
            params: data
        })
    },
    productDetails(data) { // 产品中心详情
        return axios({
            method: 'GET',
            url: getUrl('/web/productDetails'),
            params: data
        })
    },
    technologyNavigation(data) { // 技术研发导航栏
        return axios({
            method: 'GET',
            url: getUrl('/web/technologyNavigation'),
            params: data
        })
    },
    technologyDetails(data) { // 技术研发详情
        return axios({
            method: 'GET',
            url: getUrl('/web/technologyDetails'),
            params: data
        })
    },
    customerNavigation(data) { // 客户服务导航栏
        return axios({
            method: 'GET',
            url: getUrl('/web/customerNavigation'),
            params: data
        })
    },
    customerDetails(data) { // 客户服务详情
        return axios({
            method: 'GET',
            url: getUrl('/web/customerDetails'),
            params: data
        })
    },
    download(data) { // 客户服务文件下载
        return axios({
            method: 'GET',
            url: getUrl('/web/download'),
            params: data
        })
    },
    feedback(data) { // 客户服务留言
        return axios({
            method: 'POST',
            url: getUrl('/web/feedback'),
            data: data
        })
    },
    feedbackTable(data) { // 客户服务留言列表
        return axios({
            method: 'GET',
            url: getUrl('/web/feedbackTable'),
            params: data
        })
    },
    enterpriseNavigation(data) { // 企业文化导航栏
        return axios({
            method: 'GET',
            url: getUrl('/web/enterpriseNavigation'),
            params: data
        })
    },
    enterpriseDetails(data) { // 企业文化详情
        return axios({
            method: 'GET',
            url: getUrl('/web/enterpriseDetails'),
            params: data
        })
    },
    enterpriseTable(data) { // 企业文化列表
        return axios({
            method: 'GET',
            url: getUrl('/web/enterpriseTable'),
            params: data
        })
    },
    partyGroupNavigation(data) { // 党群工作导航栏
        return axios({
            method: 'GET',
            url: getUrl('/web/partyGroupNavigation'),
            params: data
        })
    },
    partyGroupDetails(data) { // 党群工作详情
        return axios({
            method: 'GET',
            url: getUrl('/web/partyGroupDetails'),
            params: data
        })
    },
    allPartyGroupTable(data) { // 党群工作全部列表
        return axios({
            method: 'GET',
            url: getUrl('/web/allPartyGroupTable'),
            params: data
        })
    },
    partyGroupTable(data) { // 党群工作列表
        return axios({
            method: 'GET',
            url: getUrl('/web/partyGroupTable'),
            params: data
        })
    },
    personalCenterNavigation(data) { // 个人中心导航栏
        return axios({
            method: 'GET',
            url: getUrl('/web/personalCenterNavigation'),
            params: data
        })
    },
    personalCenterTable(data) { // 个人中心列表
        return axios({
            method: 'GET',
            url: getUrl('/web/personalCenterTable'),
            params: data
        })
    },
    confirmReceipt(data) { // 个人中心确认收货
        return axios({
            method: 'POST',
            url: getUrl('/web/confirmReceipt'),
            data: data
        })
    },
    add(data) { // 个人中心新增
        return axios({
            method: 'POST',
            url: getUrl('/web/add'),
            data: data
        })
    },
    addCart(data) { // 加入购物车
        return axios({
            method: 'POST',
            url: getUrl('/web/addCart'),
            data: data
        })
    },
    cartList(data) { // 购物车列表
        return axios({
            method: 'GET',
            url: getUrl('/web/cartList'),
            params: data
        })
    },
    deleteCart(data) { // 删除购物车
        return axios({
            method: 'POST',
            url: getUrl('/web/deleteCart'),
            data: data
        })
    },
    settlement(data) { // 购物车结算
        return axios({
            method: 'GET',
            url: getUrl('/web/settlement'),
            params: data
        })
    },
    updateCart(data) { // 增加减少购物车
        return axios({
            method: 'POST',
            url: getUrl('/web/updateCart'),
            data: data
        })
    }
}

export default iotHome